import { useEffect, useState } from 'react';

import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../../appStores';
import { BotonesTiendas } from '../BotonesTiendas';

/*
 * «Descarga la app» (sección 17, 15 oct 2026): después de la primera factura,
 * con un QR que lleva a la tienda del teléfono que lo escanea. Los enlaces
 * son los de appStores.ts (los mismos de la Ayuda).
 * Las dos fichas son públicas desde el 15 oct 2026.
 */

/** Ruta pública de la web que manda a la tienda del teléfono (ver DescargarPage). */
export const RUTA_DESCARGAR = '/descargar';

/** La tienda que toca según el teléfono; en una computadora, ninguna. */
export function tiendaDe(userAgent: string): string | null {
  if (/android/i.test(userAgent)) return GOOGLE_PLAY_URL;
  if (/iphone|ipad|ipod/i.test(userAgent) || (/macintosh/i.test(userAgent) && /mobile/i.test(userAgent))) return APP_STORE_URL;
  return null;
}

function Qr({ url }: { url: string }): JSX.Element {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    let vivo = true;
    void import('qrcode-generator').then((m) => {
      const crear = (m as unknown as { default: (t: number, e: string) => { addData(s: string): void; make(): void; createSvgTag(o: { cellSize: number; margin: number; scalable?: boolean }): string } }).default;
      const q = crear(0, 'M');
      q.addData(url);
      q.make();
      if (vivo) setSvg(q.createSvgTag({ cellSize: 4, margin: 1, scalable: true }));
    });
    return () => { vivo = false; };
  }, [url]);
  // eslint-disable-next-line react/no-danger
  return <div className="pp-app__qr" role="img" aria-label="Código QR para descargar la app de Alexia" dangerouslySetInnerHTML={svg ? { __html: svg } : undefined} />;
}

/** QR (lleva a la tienda del teléfono que lo escanea) y los dos enlaces. */
export function DescargaApp(): JSX.Element {
  return (
    <div className="pp-app">
      <Qr url={`${window.location.origin}${RUTA_DESCARGAR}`} />
      <BotonesTiendas className="pp-app__tiendas" />
    </div>
  );
}

/**
 * /descargar: lo abre el QR desde el teléfono y manda a su tienda. Es
 * pública (no mira la sesión), como /costeo. En una computadora enseña los
 * dos enlaces.
 */
export function DescargarPage(): JSX.Element {
  const tienda = typeof navigator !== 'undefined' ? tiendaDe(navigator.userAgent) : null;
  useEffect(() => {
    if (tienda) window.location.replace(tienda);
  }, [tienda]);
  return (
    <div className="login">
      <div className="login__card">
        <h1 className="login__title">Alexia en tu teléfono</h1>
        <p className="login__text">{tienda ? 'Te llevo a la tienda…' : 'Descarga la app y entra con la misma cuenta.'}</p>
        <BotonesTiendas alto={48} className="login__tiendas" />
      </div>
    </div>
  );
}
